import { useQuery } from "react-query"
import * as api from '../api'
import { Params } from "../commonTypes"

export const useSettingsQuery = (params: Params.Settings) => {
    return useQuery(['settings', params], () => api.settings(params))
}